var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m15.72 12.2 7.454 7.454-3.279 3.279-7.454-7.455Zm5.333 7.454L15.72 14.32l-1.158 1.157 5.333 5.333ZM10.687 11.938 6.586 7.985l1.04-1.08 4.1 3.953Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m4.385 1.264 4.558 3.962v3.726l-3.741.172L.826 4.718ZM7.443 5.91l-3-2.609-1.481 1.437L5.8 7.595l1.645-.075ZM4.672 22.759 1.393 19.48l6.443-6.443 3.114.209.161 3.075ZM3.514 19.48l1.158 1.158 4.906-4.905-.056-1.079-1.106-.074Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m10.132 15.113-1.06-1.06 7.416-7.416 1.06 1.06Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#12223e",
  d: "m21.999 6.672-4.274-3.879-.816.973V1.728l-.816-.66L12.9 4.792l.519.6 2.293-.2-.828.986 3.121 3.113 1.153-1.186 2.594 2.149.445-.642Z"
})));
export { SvgServiceHistory as ReactComponent };
export default "/_next/static/images/service_history.svg";